module.exports = __webpack_public_path__ + "static/media/logo-smartbip.eb18e3a2.png";